/**
 * The plan terms (mission 9 WP12 T074; sheet 08 callouts 10 and 11, and 22/10's terms part; B.2, B.4,
 * SAT.5, TX.8, A.3; FR-023, C-010; squad U14, U25; contracts/ui-api.md "Sheet 08").
 *
 * One list, in the drawn order:
 * - the allowance per monthly cycle, which does not roll over (`planTermsAllowance`, B.2);
 * - the assistant's ceiling per cycle (`planTermsAssistant`, SAT.5; 22/10's terms part);
 * - transmission uses no credits (`planTermsTransmission`, TX.8);
 * - there is no per-user fee (`planTermsNoSeatFee`, A.3);
 * - the overage line (`planTermsOverage`, B.4): blocks from the smallest tier's price and size, and a
 *   block's lifetime in months. With no tier on sale the line is not stated.
 * Every figure is an argument from the billing read's `terms` and `tiers`, never a literal (C-010); the
 * price is in mono.
 */
import type { BillingTerms, CreditTier } from '@/lib/api/billing'
import { money } from '@/lib/format'
import { PROVISIONAL_COPY, copyText } from '@/lib/provisional-copy'

import { withMonoPrice } from './PlanToggle'

export interface PlanTermsProps {
  terms: BillingTerms
  tiers: readonly CreditTier[]
}

function overage(tier: CreditTier, months: number) {
  const price = money(tier.price_cents)
  return withMonoPrice(PROVISIONAL_COPY.planTermsOverage.render({ price, unit: tier.credits, months }), price)
}

export function PlanTerms({ terms, tiers }: PlanTermsProps) {
  const [smallest] = tiers
  return (
    <ul className="flex list-disc flex-col gap-1 pl-5 text-body text-navy-950">
      <li>{PROVISIONAL_COPY.planTermsAllowance.render({ allowance: terms.allowance_per_cycle })}</li>
      <li>{PROVISIONAL_COPY.planTermsAssistant.render({ ceiling: terms.assistant_ceiling })}</li>
      <li>{copyText('planTermsTransmission')}</li>
      <li>{copyText('planTermsNoSeatFee')}</li>
      {smallest === undefined ? null : <li>{overage(smallest, terms.block_ttl_months)}</li>}
    </ul>
  )
}
